// import React, { useState } from "react";
// import concreteData from "../../../utils/estimateCalculator.json";
// import ReadinessScore from "./ReadinessScore";
// import CalculatorNotes from "./CalculatorNotes";
// import QuickChecklist, { initialChecklist } from "./QuickChecklist";
// import DownloadEstimatePDF from "./DownloadEstimatePDF";
// import CalculatorInquiryModal from "../Common/CalculatorInquiryModal";

// const EstimateCalculator = () => {
//   const [grade, setGrade] = useState("");
//   const [type, setType] = useState("");
//   const [distance, setDistance] = useState("");
//   const [pumping, setPumping] = useState(false);

//   const [result, setResult] = useState(null);
//   const [checklist, setChecklist] = useState(initialChecklist);
//   const [showInquiryModal, setShowInquiryModal] = useState(false);
//   const [allowDownload, setAllowDownload] = useState(false);

//   const dieselPrice = 105;
//   const mileage = 6.5;
//   const operationalCost = 700;

//   const types = grade ? concreteData.concreteData[grade] || [] : [];

//   const handleCalculate = () => {
//     const selected = types.find((item) => item.type === type);
//     const mixturePrice = selected ? selected.price : 0;

//     const distanceCost = distance
//       ? ((Number(distance) / 1) * dieselPrice) / mileage + 350
//       : 0;

//     const pumpingCost = pumping ? 250 : 0;

//     const total = mixturePrice + pumpingCost + distanceCost + operationalCost;

//     setResult({
//       mixturePrice,
//       distanceCost,
//       pumpingCost,
//       total,
//     });
//   };

//   const handleClear = () => {
//     setGrade("");
//     setType("");
//     setDistance("");
//     setPumping(false);
//     setResult(null);
//   };

//   const handleDistanceChange = (e) => {
//     const value = e.target.value;
//     if (/^\d*$/.test(value)) {
//       setDistance(value);
//     }
//   };

//   const checkedCount = checklist.filter((item) => item.checked).length;

//   const scoreMap = {
//     0: 0,
//     1: 20,
//     2: 35,
//     3: 45,
//     4: 55,
//     5: 65,
//     6: 75,
//     7: 82,
//     8: 89,
//     9: 95,
//   };

//   const readinessScore = scoreMap[checkedCount];

//   const calculatorName = "Estimate Calculation";

//   return (
//     <div className="p-6 bg-white rounded-2xl shadow-xl border w-full">
//       <h2 className="text-xl font-semibold font-heading text-gray-800 mb-8">
//         {calculatorName}
//       </h2>

//       <div className="flex flex-col space-y-5">
//         {/* Grade & Type */}

//         <div className="w-full space-y-1">
//           <label className="text-base text-gray-700 font-medium">
//             Select Grade
//           </label>
//           <select
//             value={grade}
//             onChange={(e) => {
//               setGrade(e.target.value);
//               setType("");
//             }}
//             className="p-2 border rounded-lg w-full"
//           >
//             <option value="">Select Grade</option>
//             {Object.keys(concreteData.concreteData).map((g) => (
//               <option key={g} value={g}>
//                 {g}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div className="w-full space-y-1">
//           <label className="text-base text-gray-700 font-medium">
//             Select Type
//           </label>
//           <select
//             value={type}
//             onChange={(e) => setType(e.target.value)}
//             disabled={!grade}
//             className="p-2 border rounded-lg w-full"
//           >
//             <option value="">Select Type</option>
//             {types.map((item) => (
//               <option key={item.type} value={item.type}>
//                 {item.type}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Distance */}
//         <div className="space-y-1">
//           <label className="text-base text-gray-700 font-medium">
//             Distance From Our Plant Up and Down
//           </label>
//           <input
//             type="text"
//             value={distance}
//             onChange={handleDistanceChange}
//             className="p-2 border rounded-lg w-full"
//           />
//         </div>

//         {/* Pumping */}
//         <div className="space-y-1">
//           <label className="text-base text-gray-700 font-medium">
//             Pumping Required
//           </label>
//           <select
//             value={pumping ? "yes" : "no"}
//             onChange={(e) => setPumping(e.target.value === "yes")}
//             className="p-2 border rounded-lg w-full"
//           >
//             <option value="no">No</option>
//             <option value="yes">Yes</option>
//           </select>
//         </div>

//         {/* <div className="flex justify-between text-sm">
//           <span className="text-base text-gray-700 font-medium">
//             Operational and Other Cost -
//           </span>
//           <span className="text-base text-gray-700 font-medium">
//             ₹ {operationalCost}
//           </span>
//         </div> */}

//         <div className="flex gap-3 ">
//           <button
//             onClick={handleCalculate}
//             className="flex-1 bg-btnColor hover:bg-btnHoverColor text-white py-2.5 rounded-xl  transition-all duration-200 shadow-md hover:shadow-lg active:scale-95"
//           >
//             Action
//           </button>

//           <button
//             onClick={handleClear}
//             className="flex-1 border border-gray-300 text-gray-700 hover:text-white py-2.5 rounded-xl bg-gray-200 hover:bg-gray-800 transition-all duration-200 active:scale-95"
//           >
//             Clear
//           </button>
//         </div>

//         {/* Result */}
//         {result && (
//           <div className="border-t pt-4 space-y-2">
//             {/* <div className="flex justify-between">
//               <span>Mix Price</span>
//               <span>₹ {result.mixturePrice}</span>
//             </div>

//             <div className="flex justify-between">
//               <span>Distance Cost</span>
//               <span>₹ {result.distanceCost.toFixed(2)}</span>
//             </div>

//             <div className="flex justify-between">
//               <span>Pumping</span>
//               <span>₹ {result.pumpingCost}</span>
//             </div> */}

//             <div className="flex justify-between font-bold text-lg">
//               <span>Total</span>
//               <span>₹ {result.total.toFixed(0)}</span>
//             </div>
//             {result && (
//               <>
//                 <QuickChecklist
//                   checklist={checklist}
//                   setChecklist={setChecklist}
//                 />
//                 <ReadinessScore score={readinessScore} />
//                 <CalculatorNotes />

//                 {/* Two‑column layout for buttons */}
//                 <div className="flex flex-col sm:flex-row gap-4 mt-6">
//                   <div className="flex-1">
//                     {allowDownload ? (
//                       <DownloadEstimatePDF
//                         calculatorName={calculatorName}
//                         score={readinessScore}
//                         grade={grade}
//                         type={type}
//                         distance={distance}
//                         pumping={pumping}
//                         result={result}
//                         phone="+91 919124001120"
//                         checklist={checklist}
//                         handleClear={handleClear}
//                         autoDownload={allowDownload}
//                         onAutoDownloadComplete={() => setAllowDownload(false)}
//                       />
//                     ) : (
//                       <button
//                         className="w-full bg-green-600 text-white py-3 rounded-xl hover:bg-green-700 transition"
//                         onClick={() => setShowInquiryModal(true)}
//                       >
//                         Generate PDF
//                       </button>
//                     )}
//                   </div>
//                   <div className="flex-1">
//                     <a
//                       href="tel:+919124001120"
//                       className="block w-full text-center bg-btnColor text-white py-3 rounded-lg hover:bg-btnHoverColor transition"
//                     >
//                       📞 Call for Enquiry
//                     </a>
//                   </div>
//                 </div>
//               </>
//             )}
//           </div>
//         )}
//       </div>
//       {showInquiryModal && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg overflow-hidden w-full max-w-md relative">
//             <button
//               onClick={() => setShowInquiryModal(false)}
//               className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
//             >
//               ✕
//             </button>
//             <CalculatorInquiryModal
//               calculatorName={calculatorName}
//               onSuccess={() => {
//                 setShowInquiryModal(false);
//                 setAllowDownload(true);
//               }}
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default EstimateCalculator;



import React, { useEffect, useState } from "react";
import api from "../../../configs/api";
import ReadinessScore from "./ReadinessScore";
import CalculatorNotes from "./CalculatorNotes";
import QuickChecklist, { initialChecklist } from "./QuickChecklist";
import DownloadEstimatePDF from "./DownloadEstimatePDF";
import CalculatorInquiryModal from "../Common/CalculatorInquiryModal";

const EstimateCalculator = () => {
  // ---- Live pricing data (was: static estimateCalculator.json) ----
  const [concreteData, setConcreteData] = useState({});
  const [dataLoading, setDataLoading] = useState(true);
  const [dataError, setDataError] = useState(false);

  const [grade, setGrade] = useState("");
  const [type, setType] = useState("");
  const [distance, setDistance] = useState("");
  const [pumping, setPumping] = useState(false);

  const [result, setResult] = useState(null);
  const [checklist, setChecklist] = useState(initialChecklist);
  const [showInquiryModal, setShowInquiryModal] = useState(false);
  const [allowDownload, setAllowDownload] = useState(false);

  const dieselPrice = 105;
  const mileage = 6.5;
  const operationalCost = 700;

  useEffect(() => {
    const fetchPricing = async () => {
      try {
        setDataLoading(true);
        setDataError(false);

        const res = await api.get("/concrete-mix/grouped");
        setConcreteData(res.data?.data?.concreteData || {});
      } catch (err) {
        console.error("Failed to load concrete pricing:", err);
        setDataError(true);
      } finally {
        setDataLoading(false);
      }
    };

    fetchPricing();
  }, []);

  const types = grade ? concreteData[grade] || [] : [];

  const handleCalculate = () => {
    const selected = types.find((item) => item.type === type);
    const mixturePrice = selected ? selected.price : 0;

    const distanceCost = distance
      ? ((Number(distance) / 1) * dieselPrice) / mileage + 350
      : 0;

    const pumpingCost = pumping ? 250 : 0;

    const total = mixturePrice + pumpingCost + distanceCost + operationalCost;

    setResult({
      mixturePrice,
      distanceCost,
      pumpingCost,
      total,
    });
  };

  const handleClear = () => {
    setGrade("");
    setType("");
    setDistance("");
    setPumping(false);
    setResult(null);
  };

  const handleDistanceChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setDistance(value);
    }
  };

  const checkedCount = checklist.filter((item) => item.checked).length;

  const scoreMap = {
    0: 0,
    1: 20,
    2: 35,
    3: 45,
    4: 55,
    5: 65,
    6: 75,
    7: 82,
    8: 89,
    9: 95,
  };

  const readinessScore = scoreMap[checkedCount];

  const calculatorName = "Estimate Calculation";

  return (
    <div className="p-6 bg-white rounded-2xl shadow-xl border w-full">
      <h2 className="text-xl font-semibold font-heading text-gray-800 mb-8">
        {calculatorName}
      </h2>

      <div className="flex flex-col space-y-5">
        {/* Grade & Type */}

        <div className="w-full space-y-1">
          <label className="text-base text-gray-700 font-medium">
            Select Grade
          </label>
          <select
            value={grade}
            onChange={(e) => {
              setGrade(e.target.value);
              setType("");
            }}
            disabled={dataLoading || dataError}
            className="p-2 border rounded-lg w-full disabled:bg-gray-100 disabled:text-gray-400"
          >
            <option value="">
              {dataLoading
                ? "Loading grades..."
                : dataError
                  ? "Failed to load"
                  : "Select Grade"}
            </option>
            {Object.keys(concreteData).map((g) => (
              <option key={g} value={g}>
                {g}
              </option>
            ))}
          </select>
        </div>

        <div className="w-full space-y-1">
          <label className="text-base text-gray-700 font-medium">
            Select Type
          </label>
          <select
            value={type}
            onChange={(e) => setType(e.target.value)}
            disabled={!grade}
            className="p-2 border rounded-lg w-full disabled:bg-gray-100 disabled:text-gray-400"
          >
            <option value="">Select Type</option>
            {types.map((item) => (
              <option key={item.type} value={item.type}>
                {item.type}
              </option>
            ))}
          </select>
        </div>

        {dataError && (
          <p className="text-sm text-red-500">
            Couldn't load current pricing. Please refresh the page.
          </p>
        )}

        {/* Distance */}
        <div className="space-y-1">
          <label className="text-base text-gray-700 font-medium">
            Distance From Our Plant Up and Down
          </label>
          <input
            type="text"
            value={distance}
            onChange={handleDistanceChange}
            className="p-2 border rounded-lg w-full"
          />
        </div>

        {/* Pumping */}
        <div className="space-y-1">
          <label className="text-base text-gray-700 font-medium">
            Pumping Required
          </label>
          <select
            value={pumping ? "yes" : "no"}
            onChange={(e) => setPumping(e.target.value === "yes")}
            className="p-2 border rounded-lg w-full"
          >
            <option value="no">No</option>
            <option value="yes">Yes</option>
          </select>
        </div>

        <div className="flex gap-3 ">
          <button
            onClick={handleCalculate}
            disabled={!grade || !type}
            className="flex-1 bg-btnColor hover:bg-btnHoverColor text-white py-2.5 rounded-xl transition-all duration-200 shadow-md hover:shadow-lg active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100"
          >
            Action
          </button>

          <button
            onClick={handleClear}
            className="flex-1 border border-gray-300 text-gray-700 hover:text-white py-2.5 rounded-xl bg-gray-200 hover:bg-gray-800 transition-all duration-200 active:scale-95"
          >
            Clear
          </button>
        </div>

        {/* Result */}
        {result && (
          <div className="border-t pt-4 space-y-2">
            <div className="flex justify-between font-bold text-lg">
              <span>Total</span>
              <span>₹ {result.total.toFixed(0)}</span>
            </div>
            {result && (
              <>
                <QuickChecklist
                  checklist={checklist}
                  setChecklist={setChecklist}
                />
                <ReadinessScore score={readinessScore} />
                <CalculatorNotes />

                {/* Two‑column layout for buttons */}
                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                  <div className="flex-1">
                    {allowDownload ? (
                      <DownloadEstimatePDF
                        calculatorName={calculatorName}
                        score={readinessScore}
                        grade={grade}
                        type={type}
                        distance={distance}
                        pumping={pumping}
                        result={result}
                        phone="+91 919124001120"
                        checklist={checklist}
                        handleClear={handleClear}
                        autoDownload={allowDownload}
                        onAutoDownloadComplete={() => setAllowDownload(false)}
                      />
                    ) : (
                      <button
                        className="w-full bg-green-600 text-white py-3 rounded-xl hover:bg-green-700 transition"
                        onClick={() => setShowInquiryModal(true)}
                      >
                        Generate PDF
                      </button>
                    )}
                  </div>
                  <div className="flex-1">
                    <a
                      href="tel:+919124001120"
                      className="block w-full text-center bg-btnColor text-white py-3 rounded-lg hover:bg-btnHoverColor transition"
                    >
                      📞 Call for Enquiry
                    </a>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
      {showInquiryModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg overflow-hidden w-full max-w-md relative">
            <button
              onClick={() => setShowInquiryModal(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
            >
              ✕
            </button>
            <CalculatorInquiryModal
              calculatorName={calculatorName}
              onSuccess={() => {
                setShowInquiryModal(false);
                setAllowDownload(true);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default EstimateCalculator;